import { z } from "zod";
import { OwnerDocumentType } from "./owner-document-type.js";
export const createOwnerDocumentSchema = z
    .object({
    type: z.enum(Object.values(OwnerDocumentType)),
    name: z.string().min(1, { message: "Name is required" }).max(200, { message: "Name must be at most 200 characters" }),
    file_url: z.url({ message: "File URL must be a valid URL" }),
})
    .strict();
